import NetworkBinding from 'growth-payments-core/binding/networkBinding';
import { fetchPaymentsAccountEligibility } from 'growth-payments-core/api/eligibility';
import { createNetworkHook } from 'growth-payments-core/binding/useNetworkBinding';
export const eligibilityBinding = new NetworkBinding(fetchPaymentsAccountEligibility);
export const useEligibilityBinding = createNetworkHook(eligibilityBinding);